import { type FC } from 'preact/compat';

import { useAppActions } from '@/shared/stores/app-store/app-store';

import s from './dev-banner.module.scss';

interface Props {
  showDevMenu: boolean;
}

export const DevBanner: FC<Props> = ({ showDevMenu }) => {
  const { hydrate } = useAppActions();

  const toggleShowDevMenu = () => hydrate({ showDevMenu: !showDevMenu });

  return (
    <div className={s['go-to-dev']} onClick={toggleShowDevMenu}>
      {showDevMenu ? 'EXIT' : 'DEV'}
    </div>
  );
};
